export default __webpack_public_path__ + "static/media/nodeInfluencers.6a6730a8.gif";